import React, {useCallback, useEffect, useMemo, useState} from "react"
import {Button, Descriptions, Modal, Tag} from "antd"
import {Helmet} from "react-helmet-async"
import {useDispatch, useSelector} from "react-redux"
import {NavLink, useHistory, useParams} from "react-router-dom"
import {StateType} from "../../store/store"
import {BackButton} from "../../components/BackButton/BackButton"
import {Loading} from "../../components/Loading/Loading"
import moment from "moment/moment"
import {deleteUser, getUser, setUser, setWSUser} from "../../store/userReducer"
import {ID_SYSTEM_COMPANY} from "../../constants/constants"
import {deleteUserGroup, getUserGroup} from "../../store/userGroupReducer"

export const User = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const id = parseInt(useParams<{ id: string }>()?.id, 10)
    const status = useSelector((state: StateType) => state.appReducer.status)
    const profile = useSelector((state: StateType) => state.appReducer.profile)
    const user = useSelector((state: StateType) => state.userReducer.user)
    const ws = useSelector((state: StateType) => state.userReducer.ws)
    const [showModal, setShowModal] = useState(false)
    const controller = useMemo(() => new AbortController(), [id])

    useEffect(() => {
        if (id) dispatch(getUser({id, controller}))

        return () => {
            controller.abort()
            dispatch(setUser(null))
        }
    }, [dispatch, id, controller])

    useEffect(() => {
        if (ws && ws.id === id) {
            dispatch(getUser({id, controller, withoutLoadingIndicator: true}))
        }
        dispatch(setWSUser(null))
    }, [dispatch, ws, id, controller])

    const deleteHandler = useCallback(async () =>
    {
        if (user?.id)
        {
            const {payload}: any = await dispatch(deleteUser(user.id))
            if (payload?.status === 0)
            {
                setShowModal(false)
                if (payload?.message === "Удалено") history.goBack()
                else dispatch(getUser({id, controller}))
            }
        }
    }, [user, history, id, controller])

    if (!user) return <Loading/>

    return (
        <div className="description-page">
            <Helmet>
                <title>{user?.name}</title>
            </Helmet>
            <div className="description-header">
                <BackButton onClick={() => history.goBack()}/>
                <div>
                    <Button type="link" onClick={() => history.push(`/userForm`, {user})}>Редактировать</Button>
                    <Button type="link" danger onClick={() => setShowModal(true)}>Удалить</Button>
                </div>
            </div>

            <Descriptions bordered column={{xs: 1, sm: 1, md: 2}}>
                <Descriptions.Item label="ФИО">{user?.name}</Descriptions.Item>
                <Descriptions.Item label="ID">{user?.id}</Descriptions.Item>
                {
                    profile?.idCompany === ID_SYSTEM_COMPANY
                        ? <Descriptions.Item label="Компания">
                            <NavLink to={`/company/${user.idCompany}`}>{user.nameCompany}</NavLink>
                        </Descriptions.Item>
                        : null
                }
                <Descriptions.Item label="Группа">
                    <NavLink to={`/userGroup/${user.idUserGroup}`}>{user.nameUserGroup}</NavLink>
                </Descriptions.Item>
                <Descriptions.Item label="Роль">{user.nameUserType}</Descriptions.Item>
                <Descriptions.Item label="Email">{user.email}</Descriptions.Item>
                <Descriptions.Item label="Телефон">{user.phone}</Descriptions.Item>
                <Descriptions.Item label="Telegram ID">{user.telegramId}</Descriptions.Item>
                <Descriptions.Item label="Создан">{moment(user?.createdAt).format('DD.MM.YYYY HH:mm')}</Descriptions.Item>
                <Descriptions.Item label="Обновлен">{moment(user?.updatedAt).format('DD.MM.YYYY HH:mm')}</Descriptions.Item>
                <Descriptions.Item label="Подтвержден">
                    <div className="description-item-status">
                        <Tag color={user.verify ? 'green' : 'volcano'} style={{marginRight: 0}}>{user.verify ? 'Да' : 'Нет'}</Tag>
                    </div>
                </Descriptions.Item>
                <Descriptions.Item label="Статус">
                    <div className="description-item-status">
                        <Tag color={user.active ? 'green' : 'volcano'} style={{marginRight: 0}}>{user.active ? 'Активно' : 'Не активно'}</Tag>
                    </div>
                </Descriptions.Item>
            </Descriptions>

            <Modal title={`Вы уверены что хотите удалить пользователя`}
                   centered
                   open={showModal}
                   onOk={deleteHandler}
                   onCancel={() => setShowModal(false)}
                   okText="Да"
                   okButtonProps={{loading: status === "loading"}}
            />
        </div>
    )
}